import { keyframes } from '@emotion/core'
import styled from '@themes/theme'

const attendancePulseAni = keyframes`
 0% {
   transform: translate(-50%,-50%) scale(0.95);
   box-shadow: 0 0 0 0 rgba(255,197,21,.6);
 }
 70% {
   transform: translate(-50%,-50%) scale(1);
   box-shadow: 0 0 0 10px rgba(255,197,21,0);
 }
 100% {
   transform: translate(-50%,-50%) scale(0.95);
   box-shadow: 0 0 0 0 rgba(255,197,21,0);
 }
`
export const AttendanceWrap = styled.div`
  padding-top: 18px;
  background: ${props => props.theme.color.themeTxt};
}
  .event-tit {
    color: ${props => props.theme.color.modalTxt};
    font-size: ${props => props.theme.font.large};
  }
  .event-period {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 210px;
    height: 26px;
    margin: 8px auto 4px;
    color: ${props => props.theme.color.modalTxt};
    background: ${props => props.theme.color.modalBg};
    border-radius: 40px;
  }
  .event-notice {
    color: ${props => props.theme.color.btn};
    font-size: ${props => props.theme.font.small};
  }
  .attendance-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 10px;
    padding: 5px 7px;
    background: ${props => props.theme.color.gray};
    max-height: 50dvh;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: block;
    }
    &--item {
      position: relative;
      width: calc((100% - 10px) / 3);
      height: 105px;
      margin-bottom: 5px;
      &:nth-last-child(1):nth-child(7) {
        flex: 1;
        margin-bottom: 0;
      }
      .reward-btn {
        z-index: 0;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 100%;
        border-radius: 3px;
        background: ${props => props.theme.color.themeTxt};
        overflow: hidden;
        &--day {
          margin-top: 6px;
          color: ${props => props.theme.color.modalTxt};
          font-size: ${props => props.theme.font.small};
        }
        &--ico {
          width: auto;
          height: 26px;
        }
        &--num {
          color: ${props => props.theme.color.modalTxt};
        }
        &--txt {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 24px;
          margin-bottom: -1px;
          background: ${props => props.theme.color.modalBg};
          color: ${props => props.theme.color.gray};
          font-size: ${props => props.theme.font.small};
        }
        &.active {
          .reward-btn--txt {
            color: ${props => props.theme.color.themeTxt};
            background: ${props => props.theme.color.modalyellow};
            &.complete {
              color: ${props => props.theme.color.gray};
              background: ${props => props.theme.color.modalBg};
            }
          }
        }
      } /* reward-btn */
      .reward-complete {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        border-radius: 3px;
        background: rgba(28, 32, 43, .75);
        .check-ico {
          position: relative;
          width: 30px;
          height: 30px;
          transform: rotate(45deg) translate(-15px, -10px);
          &::before, &::after {
            content: '';
            display: block;
            position: absolute;
            bottom: 0;
            right: 0;
            background: ${props => props.theme.color.themeTxt};
          }
          &::before {
            width: 65%;
            height: 4px;
          }
          &::after {
            width: 4px;
            height: 100%;
          }
        }
      }
    }
    // 일반출석체크
    &.common {
      background: none;
      padding: 5px 7px 13px;
      justify-content: flex-start;
      .attendance-list--item {
        width: calc((100% - 16px) / 5);
        height: 56px;
        border-radius: 3px;
        margin: 0 4px 4px 0;
        &:nth-of-type(5n) {
          margin: 0 0 4px 0;
          .reward-btn {
            background: #E4F7FF;
            border: 1.5px solid #B2DDF1;
          }
          &:last-of-type {
            .reward-btn {
              background: #E4F7FF;
              border: 1.5px solid #009FE3;
            }
          }
        }
        .reward-btn {
          background: ${props => props.theme.color.white};
          position: relative;
          &--day {
            margin-top: 0;
            position: absolute;
            top: 5px;
            left: 5px;
            color: ${props => props.theme.color.btn};
            font-size: ${props => props.theme.font.large};
          }
          &--ico {
            margin-top: 18px;
            svg {
              width: 19px;
              height: auto;
              margin-left: 1px;
            }
            &.gray {
              svg {
                path {
                  &.attendance-color-1 {
                    fill: #E6E6E6;
                  }
                  &.attendance-color-2 {
                    fill: #D6D6D6;
                  }
                  &.attendance-color-3 {
                    fill: #FAFAFA;
                  }
                }
              }
            }
          }
          &--num {
            margin-bottom: 5px;
            color: ${props => props.theme.color.btn};
            font-size: ${props => props.theme.font.large};
            &.gray {
              color: #14141430 !important;
            }
          }
          &--bg {
            position: absolute;
            width: 100%;
            height: auto;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: -1;
          }
          .today-txt {
            width: 30px;
            height: auto;
            position: absolute;
            top: -1px;
            right: 2px;
            z-index: 1;
          }
          &.active {
            border: 1.5px solid ${props => props.theme.color.matchTit1};
            .reward-btn {
              &--day {
                color: ${props => props.theme.color.modalTxt};
              }
              &--num {
                color: ${props => props.theme.color.matchTit1};
                font-weight: ${props => props.theme.fontW.bold};
              }
            }
            ::after {
              content: '';
              display: block;
              position: absolute;
              right: 0;
              top: 0;
              width: 35px;
              height: 11px;
              background: ${props => props.theme.color.matchTit1};
              border-radius: 0 0 0 2px;
            }
          }
        } /* reward-btn */
        .reward-complete {
        background: #20304020;
        .attendance-check-ico {
          position: absolute;
          top: 20px;
          left: calc(50% + 2px);
          transform: translateX(-50%);
          width: 28px;
          height: auto;
        }
      }
      }
    }
  }
  &.not-target {
  padding: 3px 6px;
  .notice-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding: 11px 8px;
    border-radius: 3px;
    .notice-character {
      width: auto;
      height: 45px;
      margin-right: 3px;
    }
    .notice-txt-box {
      flex: 1;
      display: flex;
      flex-flow: column;
      text-align: left;
      &--date {
        margin-bottom: 2px;
        font-size: ${props => props.theme.font.large};
        color: ${props => props.theme.color.modalTxt};
      }
      &--txt {
        font-weight: ${props=>props.theme.fontW.medium};
        color: ${props => props.theme.color.modalTxt};
      }
    }
  }













 //
 //
 //
 //  padding: 1px 0 6px;
 //  background: ${props => props.theme.color.modalSubTxt};
 //  .sub-info {
 //    display: flex;
 //    flex-flow: column;
 //    justify-content: center;
 //    width: 100%;
 //    height: 53px;
 //    background: ${props => props.theme.color.modalBg};
 //    .event-period {
 //      color: ${props => props.theme.color.modalTxt};
 //    }
 //    .event-notice {
 //      font-size: ${props => props.theme.font.small};
 //      color: ${props => props.theme.color.disableTxt};
 //    }
 //  }
 //  .attendance-list {
 //    display: flex;
 //    flex-wrap: wrap;
 //    justify-content: space-between;
 //    padding: 6px 6px 0;
 //    border-radius: 3px;
 //    max-height: 65vh;
 //    overflow:auto;
 //    &--item {
 //      position: relative;
 //      width: calc((100% - 15px) / 4);
 //      height: 113px;
 //      margin-bottom: 5px;
 //      .reward-btn {
 //        z-index: 0;
 //        display: flex;
 //        flex-flow: column;
 //        justify-content: space-between;
 //        align-items: stretch; /* 삼성 인터넷 낮은버전(12)은 stretch를 해줘야 하단 '보상받기' 버튼 너비가 100%로 설정됨*/
 //        width: 100%;
 //        height: 100%;
 //        border-radius: 3px;
 //        background: ${props => props.theme.color.disableBg};
 //        overflow: hidden;
 //        cursor: default;
 //        &--day {
 //          margin-top: 6px;
 //          .last-reward-img {
 //            position: relative;
 //            top: -1px;
 //            width: 18px;
 //            height: auto;
 //            margin: 0 6px;
 //          }
 //        }
 //        &--ico {
 //          position: relative;
 //          width: 30px;
 //          height: 30px;
 //          margin: 9px auto 10px;
 //          svg {
 //            position: relative;
 //            width: 100%;
 //            height: auto;
 //          }
 //          // 보상 받기 가능할 경우 효과
 //          .attendance-pulse-ani {
 //            position: absolute;
 //            top: 50%;
 //            left: 50%;
 //            width: 26px;
 //            height: 26px;
 //            border-radius: 50%;
 //            &.ani-2 {
 //              width: 23px;
 //              height: 23px;
 //            }
 //            &.ani-3 {
 //              width: 20px;
 //              height: 20px;
 //            }
 //          }
 //        }
 //        &--num {
 //          margin-bottom: 5px;
 //        }
 //        &--txt {
 //          width: 100%;
 //          height: 25px;
 //          line-height: 2.5rem;
 //          margin-bottom: -1px;
 //          color: ${props => props.theme.color.disableTxt};
 //          background: ${props => props.theme.color.contentsBg};
 //
 //        }
 //        // 출석 보상 가능한 아이템
 //        &.active {
 //          cursor: pointer;
 //          background: ${props => props.theme.color.secondaryBg};
 //            .attendance-pulse-ani {
 //              animation: ${attendancePulseAni} 1.7s infinite ease-out;
 //              &.ani-2 {
 //                animation-delay: .15s;
 //              }
 //              &.ani-3 {
 //                animation-delay: .45s;
 //              }
 //            }
 //          .reward-btn--txt {
 //            color: ${props => props.theme.color.themeTxt};
 //            background: ${props => props.theme.color.blue};
 //          }
 //        }
 //      }
 //      // 출석 보상 완료
 //      .reward-complete {
 //        position: absolute;
 //        top: 0;
 //        left: 0;
 //        display: flex;
 //        justify-content: center;
 //        align-items: center;
 //        width: 100%;
 //        height: 100%;
 //        &:before {
 //          content:'';
 //          display:block;
 //          position:absolute;
 //          top: 0;
 //          left: 0;
 //          width: inherit;
 //          height: inherit;
 //          background: ${props => props.theme.color.mainBg};
 //          opacity: .8;
 //        }
 //        &--img {
 //          position: relative;
 //          width: 60px;
 //          height: auto;
 //        }
 //      }
 //      &:nth-of-type(7) {
 //        width: calc(((100% - 15px) / 2) + 5px);
 //        .reward-btn {
 //          background: ${props => props.theme.color.matchTit2};
 //          &--num {
 //            font-size: ${props => props.theme.font.large};
 //          }
 //        }
 //      }
 //    }
 //  }
 //  // 출석 체크 하단 배너
 //  .attendance-banner {
 //    display: flex;
 //    justify-content: center;
 //    align-content: center;
 //    margin: 0 6px;
 //    overflow: hidden;
 //    border-radius: 3px;
 //    &--img {
 //      width: auto;
 //      height: 145px;
 //    }
 //  }
 //
 //  &.not-target {
 //    padding: 3px 6px;
 //    .notice-wrap {
 //      display: flex;
 //      justify-content: space-between;
 //      align-items: center;
 //      padding: 11px 8px;
 //      background: ${props => props.theme.color.modalBg};
 //      border-radius: 3px;
 //      .notice-character {
 //        width: 46px;
 //        height: 35px;
 //        margin-right: 6px;
 //      }
 //      .notice-txt-box {
 //        flex: 1;
 //        display: flex;
 //        flex-flow: column;
 //        text-align: left;
 //        &--date {
 //          margin-bottom: 2px;
 //          font-size: ${props => props.theme.font.large};
 //          color: ${props => props.theme.color.modalTxt};
 //        }
 //        &--txt {
 //          font-weight: ${props=>props.theme.fontW.medium};
 //          color: ${props => props.theme.color.modalTxt};
 //        }
 //      }
 //    }
 // }
`
